import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { MyLeaveBarNew } from "../bar-new";
import { MyLeaveLeaveCardProps } from "./leave-card";

type MyLeaveLeaveCardViewProps = MyLeaveLeaveCardProps & {
  label: string;
};

export const MyLeaveLeaveCardView: React.FC<MyLeaveLeaveCardViewProps> = (data) => {
  const { label, type, ...props } = data;
  const theme = useTheme();

  return (
    <Box
      bgcolor={theme.palette.gray30.main}
      id={`${type}-leave-days-bar`}
      sx={{
        padding: "8px",
        borderRadius: "8px",
        paddingBottom: "24px",
      }}
    >
      <Typography
        variant="h6"
        sx={{ color: theme.palette.gray80.main, padding: "10px 16px" }}
      >
        {label}
      </Typography>
      <MyLeaveBarNew {...props} />
    </Box>
  );
};
